import { v4 } from 'uuid';

import { createFilterReducer } from '../filter';
import { usersFilterActions, usersFilterActionsPrefix } from '../../constants/filter';
import { dateColumns } from '../../constants/event';
import { fromFilter } from '../../converters/filterConverter';
import { USER_TEMPLATE_TYPE } from '../../constants/dashboards';

const getColumnsFromTemplate = (isAggregate, query) =>
  isAggregate
    ? query.groupBy.map((column) => ({
        id: v4(),
        value: column,
      }))
    : query.columns.map((column) => ({
        id: v4(),
        value: column,
      }));

const filterReducer = createFilterReducer(usersFilterActionsPrefix);

const initialState = {
  event: null,
  columns: [],
  aggregate: true,
  filter: filterReducer(undefined, {}),
  idUsingTemplate: undefined,
  sql: '',
  error: '',
};

const compose = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_USERS_EVENT':
      return {
        ...state,
        event: action.event,
        columns: [],
        filter: filterReducer(undefined, {}),
      };

    case 'SET_USERS_EVENT_COLUMNS_VALUE':
      return {
        ...state,
        columns: state.columns.map((c) => (c.id === action.id ? { ...c, value: action.value } : c)),
      };

    case 'ADD_USERS_EVENT_COLUMN':
      return {
        ...state,
        columns: [...state.columns, { id: v4() }],
      };

    case 'DELETE_USERS_EVENT_COLUMN':
      return {
        ...state,
        columns: state.columns.filter((c) => c.id !== action.id),
      };

    case 'AGGREGATE_USERS':
      return {
        ...state,
        aggregate: !state.aggregate,
      };

    case usersFilterActions.ADD_FILTER_CLAUSE:
    case usersFilterActions.COPY_FILTER:
    case usersFilterActions.REMOVE_FILTER:
    case usersFilterActions.REMOVE_FILTER_CLAUSE:
    case usersFilterActions.SET_FILTER_CLAUSE_FIELD:
    case usersFilterActions.SET_FILTER_CLAUSE_VALUE:
    case usersFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case usersFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case usersFilterActions.SET_FILTER_VISIBILITY:
      return {
        ...state,
        filter: filterReducer(state.filter, action),
      };

    case 'EXPOSE_USERS_QUERY_SUCCESS':
      return {
        ...state,
        error: '',
        sql: action.sql,
      };

    case 'SET_USERS_EXPOSURE_ERROR':
      return {
        ...state,
        sql: '',
        error: action.error,
      };

    case `CREATE_TEMPLATE_${USER_TEMPLATE_TYPE}_SUCCESS`:
    case `SET_TEMPLATE_${USER_TEMPLATE_TYPE}`: {
      const { query } = action.template.queries[0];
      const isAggregate = query.groupBy !== undefined;
      return {
        ...state,
        event: query.eventName,
        columns: getColumnsFromTemplate(isAggregate, query).filter(
          (column) =>
            column.value !== 'event.user_id' && !Object.values(dateColumns).includes(column.value)
        ),
        aggregate: isAggregate,
        filter: fromFilter(query.filter, (field) =>
          action.template.filterExtractor(query.eventName, field)
        ),
        idUsingTemplate: action.template.id,
      };
    }

    case `RESET_TEMPLATE_${USER_TEMPLATE_TYPE}`:
      return {
        ...state,
        idUsingTemplate: undefined,
      };

    case 'DELETE_TEMPLATE_SUCCESS':
      return {
        ...state,
        idUsingTemplate: state.idUsingTemplate === action.id ? undefined : state.idUsingTemplate,
      };

    default:
      return state;
  }
};

export default compose;

export const getEvent = (state) => state.event;

export const getColumns = (state) => state.columns;

export const isAggregateEnabled = (state) => state.aggregate;

export const getUserFilter = (state) => state.filter;

export const getIdUsingTemplate = (state) => state.idUsingTemplate;

export const getUsersSQL = (state) => state.sql;

export const getError = (state) => state.error;
